// extracted by mini-css-extract-plugin
export var icon = "uLt7ffxesCgRtUaMOWwJ";
export var root = "WI8tmIAICZsmQ3TaGfWF";
export var root_block = "ks6FY64Jpn7J_dLxP302";
export var text = "qIiSnCD0e7_YQVdQzIhl";